import { css as t, createGlobalStyle as o } from "styled-components";
const e = t`
	*,
	*::before,
	*::after {
		box-sizing: border-box;
	}

	body {
		font-weight: normal;
		font-style: normal;
		line-height: 24px;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	ul,
	ol {
		padding: 0;
	}

	body,
	h1,
	h2,
	h3,
	h4,
	p,
	ul,
	ol,
	li,
	figure,
	figcaption,
	blockquote,
	dl,
	dd {
		margin: 0;
	}

	ul,
	ol,
	li {
		list-style: none;
	}

	input,
	textarea {
		font-weight: normal;
		font-style: normal;
		line-height: 24px;
		appearance: none;
	}

	h1,
	h2,
	h3,
	h4 {
		font-weight: 600;
		font-style: normal;
	}

	h1 {
		font-size: 32px;
		letter-spacing: -0.01em;
		line-height: 40px;
	}

	h2 {
		font-size: 24px;
		line-height: 32px;
	}

	h3 {
		font-size: 24px;
		font-weight: normal;
		line-height: 32px;
	}

	h4 {
		line-height: 24px;
	}
`, i = `
    ${e}
`, l = o`
    ${e}
`;
export {
  l as ResetStylesNew,
  i as ResetStylesNewCss,
  e as resetStylesNew
};
//# sourceMappingURL=resetNew.mjs.map
